import api from './api';

export const listAssessmentTemplates = async (params = {}) => {
  const { data } = await api.get('/assessment-templates', { params });
  return data;
};

export const getAssessmentTemplate = async (id) => {
  const { data } = await api.get(`/assessment-templates/${id}`);
  return data;
};

export const createAssessmentTemplate = async (payload) => {
  const { data } = await api.post('/assessment-templates', payload);
  return data;
};

export const updateAssessmentTemplate = async (id, payload) => {
  const { data } = await api.put(`/assessment-templates/${id}`, payload);
  return data;
};

export const deleteAssessmentTemplate = async (id) => {
  const { data } = await api.delete(`/assessment-templates/${id}`);
  return data;
};

export default {
  listAssessmentTemplates,
  getAssessmentTemplate,
  createAssessmentTemplate,
  updateAssessmentTemplate,
  deleteAssessmentTemplate,
};
